/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "soundshatterapi",
            "endpoint": "https://mp58770uee.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:996ce919-2974-4ef0-9bea-2133b6c6d0ac",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_PF1Bfvuwg",
    "aws_user_pools_web_client_id": "56ok3qmhes2rbqhmtkfqm3r2md",
    "oauth": {
        "domain": "soundshatterapp03cc2581-03cc2581-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.soundshatter.com/,https://develop.soundshatter.com/",
        "redirectSignOut": "http://localhost:3000/,https://www.soundshatter.com/,https://develop.soundshatter.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SoundShatterUserData-master",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
